export default class Configuration {
    static get CONFIG () {
        return {
            authServer: "$VITE_ZN_AUTH_SERVER",
            backendServer: "$VITE_ZN_BACKEND_SERVER",
            frontendServer: "$VITE_ZN_FRONTEND_SERVER",
            trackingId: "$VITE_ZN_TRACKING_ID",
            clientId: "$VITE_ZN_CLIENT_ID",
            clientSecret: "$VITE_ZN_CLIENT_SECRET"
        };
    }

    static value (name:
                      "authServer" |
                      "backendServer" |
                      "frontendServer" |
                      "trackingId" |
                      "clientId" |
                      "clientSecret"
    ) {
        if (!(name in this.CONFIG)) {
            console.error(`Configuration: There is no key named "${name}"`);
            return;
        }

        const value = this.CONFIG[name];

        if (value == null) {
            console.error(`Configuration: Value for "${name}" is not defined`);
            return;
        }

        if (value.startsWith("$VITE_")) {
            // value was not replaced, it seems we are in development.
            // Remove $ and get current value from process.env
            const envName = value.substring(1);
            const envValue = import.meta.env[envName];
            if (envValue) {
                return envValue;
            } else {
                console.error(`Configuration: Environment variable "${envName}" is not defined`);
            }
        } else {
            // value was already replaced, it seems we are in production.
            return value;
        }
    }
}
